export const DISCOVER_RATES = 'DISCOVER_RATES';
